import React from "react";
import AnimatedSection from "./AnimatedSection.jsx";
import Technos from "./Technos.jsx";
import PropTypes from "prop-types";
import DownloadButtons from "./DownloadButtons.jsx";

function QuiSuisJeContent() {
  return (
    <>
      <div>
        <h2 className="text-3xl text-bleuciel text-center mb-5">
          Qui suis-je ?
        </h2>
      </div>
      <div className="flex flex-col md:flex-row items-center">
        <div className="mr-5">
          <figure className="w-48 h-48">
            <img
              src="/specialiste-digital-communication-marseille.png"
              alt="S. Fialon"
              className="rounded-lg text-center m-auto"
              height={100}
              width={120}
            />
            <figcaption className="text-xs mt-3 text-center">
              Sandrine Fialon
            </figcaption>
          </figure>
        </div>
        <div>
          <p className="text-3xl">Développeur Web Javascript / TypeScript</p>
          <p className="mb-3">
            Développeur Full Stack passionnée par le web, je maitrise les
            langages JavaScript pour créer des applications complètes, du
            Back-End (NodeJs) au Front-End (Next.js, React ou Vue.js).
            J&apos;intègre systématiquement le Clean Code et le SEO dans mes
            projets.
            <br /> Mon expertise s&apos;étend également au DevOps, et à la
            gestion des environnements Cloud, me permettant de couvrir
            l&apos;intégralité du cycle de vie des applications.
          </p>
          <Technos />

          <DownloadButtons />
        </div>
      </div>
    </>
  );
}

export default function QuiSuisJeSection({ isClient }) {
  return isClient ? (
    <AnimatedSection id="quisuisje" className="mx-10 bg-gray-100">
      <QuiSuisJeContent />
    </AnimatedSection>
  ) : (
    <div id="quisuisje" className="container m-auto bg-gray-100">
      <QuiSuisJeContent />
    </div>
  );
}

QuiSuisJeSection.propTypes = {
  isClient: PropTypes.bool.isRequired,
};
